import React, { Component, useContext } from 'react';
import ReactDOM from 'react-dom';
import furioosSdk, { Player } from 'furioos-sdk';
import firebase from '../../lib/firebase.prod';
import * as STORAGE_BUCKET from '../../constants/storageBucket';
import * as PROJECT_CODE from '../../constants/projectCode';
import { onUnityUpdateMessage } from './UnityLogic/ReceiveMessage';
const project_code = 'townville';

class CallFurioos extends Component {
	player;
	populatedUILeft = [];//we are going to loop through and add all elements to this... i feel this may be best made in base JS to keep up with unity
	populatedUIRight = [];
	currentIframeName;

	// Unity UI Container
	goBackButtonHolder;

	leftUiHolder;
	rightUiHolder;

	leftUiTitle;
	rightUiTitle;

	currentCategory;
	currentUnitId;
	currentRoomId;

	lastUIState = "";
	currentUiState = "inCategory";
	hasStartingUI = false;

	lastCategorySetJson;
	lastUnitSetJson;
	lastRoomSetJson;
	lastUpgradeSetJson;

	unitIdUrlImages = {};
	roomIdUrlImages = {};
	upgradeOptionsUrlImages = {};

	

	startFurioos(
		user_email,
		user_name,
		user_phone,
		user_avatar,
		user_time,
		img_file,
		user_type,
		appointmentId,
		user_id,
		callBack,
		iFrameName,
		furId
	) {
		const options = {
			whiteLabel: true,
			hideToolbar: true,
			hideTitle: true,
			hidePlayButton: false,
		};

		onUnityUpdateMessage.setLoading();

		onUnityUpdateMessage.getUnitsByCategory = (category) => {this.getUnitsByCategory(category)};
		onUnityUpdateMessage.getUnitRooms = (unitID) => {this.getUnitRooms(unitID)};
		onUnityUpdateMessage.getRoomUpgrades = (roomID, unitID) => {this.getRoomUpgrades(roomID, unitID)};
		onUnityUpdateMessage.goToRoom = (roomID, unitID) => {this.goToRoom(roomID, unitID)};
		onUnityUpdateMessage.goToUnit = (unitID) => {this.goToUnit(unitID)};
		onUnityUpdateMessage.setOption = (optionId) => {this.setOption(optionId)};
		onUnityUpdateMessage.goBack = () => {this.unityGoBack()};
		onUnityUpdateMessage.zoomTo = (thisZoom) => {this.setZoomTo(thisZoom);};

		const FinishFurioosCallBack = () =>{console.log("Finish Furioos");};

		var userEmail = user_email;
		var userFullName = user_name;
		var userPhoneNumber = user_phone;
		var userAvatarCode = user_avatar;
		var userAppointmentTimeUnix = user_time;
		var imageFile = img_file;
		var thisUserType = user_type;
		var thisAppointmentId = appointmentId;
		var thisUserId = user_id;
		var clientHasDoneTest = false;
		console.log('The time is : ' + userAppointmentTimeUnix);

		console.log('furios id ' + furId + ' iframe name ' + iFrameName);
		this.player = new Player(String(furId), iFrameName, options);
		this.currentIframeName = iFrameName;

		var self = this;


		this.player.onLoad(function () {
			// Here you know when the player is ready.
			console.log('PLAYER LOADED');
			//self.player.start();
			try {
				console.log('PLAYER LOADED once');
				self.player.start();

				//player.setQuality("AUTO");
				// var loadScreen = document.getElementById("loadingScreen");
				// var loadingGif = document.getElementById("loadingGifImg");

				// loadingGif.remove();
				// loadScreen.remove();

				// ReactDOM.unmountComponentAtNode(document.getElementById('rootCam'));
			} catch (err) {
				console.log(err + ' weird bug');
			}
		});

		this.player.onUserActive(function () {
			// Implement your own code.
			console.log('My user is active');
			//player.setQuality(Player.qualityValues.AUTO);
			//here we then need to implement passing data
		});

		this.player.onUserInactive(function () {
			// Implement your own code.
			console.log('My user is inactive');
		});

		this.player.onSessionStopped(function () {
			// Implement your own code.
			console.log('The session has been stopped');
			onUnityUpdateMessage.setFurioosOff();
			FinishFurioosCallBack();
		});

		this.player.onSDKMessage(function (data) {


			console.log('Message received from my application: ', data);
			onUnityUpdateMessage.lastDataString = onUnityUpdateMessage.currentDataString;
			onUnityUpdateMessage.currentDataString = data;
			onUnityUpdateMessage.callback();
			onUnityUpdateMessage.messageClientHostIp= (()=>{
				//be used if player loaded first
				try{
					console.log("try set host ip 1");
					var clientHostIp = { setHostIp: onUnityUpdateMessage.currentHostIp}
					self.player.sendSDKMessage(clientHostIp);
				}
				catch(err){
					//what could cause an issue here is client isnt loaded yet
					console.log("Unreal probably not loaded ", err);
				}

			});
			

			console.log(data.unityReady);

			var dataRemovedBracket = data.replace('}', '');
			dataRemovedBracket = dataRemovedBracket.replace('{', '');

			//console.log('Data removed bracket = ' + dataRemovedBracket);
			// {unityReady:true}
			var splitMessage = dataRemovedBracket.split(':');
			var dataString0 = splitMessage[0];

			//Get user info
			if (dataString0 === 'unityReady') {
				if (splitMessage[1] === 'true' && clientHasDoneTest === false) {
					//player.maximize();
					//for image file
					// console.log(imageFile);
					//var thisBody = {test:"test"};

					console.log('user time: ' + userAppointmentTimeUnix);
					var thisBody = {
						userInfo: {
							email: userEmail,
							name: userFullName,
							phoneNumber: userPhoneNumber,
							avatarCode: userAvatarCode,
							userAppointmentTime: userAppointmentTimeUnix,
							userType: thisUserType,
							appId: thisAppointmentId,
							userId: thisUserId,
							image: imageFile,
						},
					};

					onUnityUpdateMessage.currentUserInfo = thisBody.userInfo;
					console.log('BODY BEING SENT ' + JSON.stringify(thisBody));
					//var thisBody = {userInfo:{email: userEmail, name: userFullName, phoneNumber: userPhoneNumber, avatarCode: userAvatarCode, userAppointmentTime: userAppointmentTimeUnix, image: imageFile, userType: thisUserType, appId: thisAppointmentId, userId: thisUserId}};
					try {
						self.player.sendSDKMessage(thisBody);
					} catch (err) {
						console.log(
							'seems we get multiple players alive but they should be gone? ' +
								err
						);
					}
					console.log("Going to get categories now");

					if(onUnityUpdateMessage.currentHostIp){

						setTimeout(() => {

							try{
								console.log("try set host ip 2");
	
								var clientHostIp = { setHostIp: onUnityUpdateMessage.currentHostIp}
								self.player.sendSDKMessage(clientHostIp);
							}
							catch(err){
								//what could cause an issue here is client isnt loaded yet
								console.log("Unreal probably not loaded ", err);
							}

						}, 2000);
					}

					//self.getCategories();
				}
			}

			if (dataString0 === 'avatarCreatedCode') {
				if (splitMessage[1]) {
					userAvatarCode = splitMessage[1];

					console.log('GOT USER AVATAR ' + userAvatarCode);

					var currentUser = firebase.auth().currentUser;
					var thisUid = currentUser.uid;

					var userPostRef = firebase
						.database()
						.ref('/users/' + thisUid + '/avatarCode');

					userPostRef.set(userAvatarCode);
				}
			}
			//my build
			if (dataString0.includes('unit') && !dataString0.includes('unity')) {
				var removedRooms = dataRemovedBracket.replace('"rooms":[', '');
				var splitComma = removedRooms.split(',');

				createHtmlFromArray(splitComma);
				// var emailGuestPost4 = app.database().ref('/myBuildEmails/' + project_code).push();

				// emailGuestPost4.set({
				//     email: userEmail,
				//     build: "EMAIL STUFF"
				// });
			}

			//ShutDown
			//Get user info
			if (dataString0.includes('endSession')) {
				if (splitMessage[2].includes('True')) {
					try {
						self.player.stop();
					} catch (err) {
						console.log(
							'seems we get multiple players alive but they should be gone? ' +
								err
						);
					}
					//FinishFurioosCallBack();
				} else if (splitMessage[2].includes('False')) {
					try {
						self.player.stop();
					} catch (err) {
						console.log(
							'seems we get multiple p[layers alive but they should be gone? ' +
								err
						);
					}
				}
			}

			//ExtendTime
			if (dataString0 === 'extendedSession') {
				UseAnotherAppointment();
			}

			//this is where we will handle the new message system

			//allCategories
			//populateUnits
			//populateRooms
			//populateRoomUpgrades
			//optionName
			//optionPrice
			//urlRef
			//id
			//console.log("Data: " + data);
			
			
		});

		var createHtmlFromArray = (arrayForEmail) => {
			var thisHtml =
				'<div style=" margin:auto; text-align: center; vertical-align: middle; width: 65%;">';
			arrayForEmail.forEach((element) => {
				console.log('split comma = ' + element);
				// thisLineToAdd is the html for this element
				var thisLineToAdd = '';
				if (element.includes('unit')) {
					//this means this is our title
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					thisLineToAdd = '<h1>MY BUILD - ' + removedQuote + '</h1>';

					thisHtml = thisHtml + thisLineToAdd;
				}

				if (element.includes('room')) {
					//this means this is our title
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					thisLineToAdd = '<hr><h3>' + removedQuote + '</h3>';

					thisHtml = thisHtml + thisLineToAdd;
				}

				if (element.includes('lines')) {
					//this is for our current room
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[2].replace(/"/g, '');

					thisLineToAdd = '<p>' + removedQuote;

					thisHtml = thisHtml + thisLineToAdd;
				} else if (element.includes('name')) {
					//this is for our current room
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					thisLineToAdd = '<p>' + removedQuote;

					thisHtml = thisHtml + thisLineToAdd;
				}

				if (element.includes('price')) {
					//this means this is our title
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					if (removedQuote.includes('}]}]}')) {
						removedQuote = removedQuote.replace('}]}]}', '');
					} else if (removedQuote.includes('}]}')) {
						removedQuote = removedQuote.replace('}]}', '');
					}

					thisLineToAdd = ': $' + removedQuote + '<p>';

					thisHtml = thisHtml + thisLineToAdd;
				}
			});

			var emailBuild = firebase
				.database()
				.ref('/myBuildEmails/' + project_code)
				.push();

			emailBuild.set({
				email: userEmail,
				build: thisHtml,
			});

			thisHtml = thisHtml + '</div>';
			console.log('Finished Html: ' + thisHtml);
		};

		var UseAnotherAppointment = () => {
			console.log('EXTENDING SESSION');
			var d = new Date();
			var months = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			];
			var thisMonth = months[d.getMonth()];
			var thisYear = d.getFullYear();
			var yearString = thisYear.toString();

			firebase
				.database()
				.ref('/kavtek_clients/' + project_code)
				.once('value', (snapshot) => {
					if (snapshot.hasChild(yearString + thisMonth)) {
						var totalAppUsed = snapshot.child(yearString + thisMonth).val();

						var totalAppsUsedRef = firebase
							.database()
							.ref(
								'/kavtek_clients/' + project_code + '/' + yearString + thisMonth
							);

						var newTotal = totalAppUsed + 1;

						totalAppsUsedRef.set(newTotal);
						console.log('SESSION SHOULD OF BEEN EXTENDED');
					} else {
						var totalAppsUsedRef = firebase
							.database()
							.ref(
								'/kavtek_clients/' + project_code + '/' + yearString + thisMonth
							);
						var totalAppUsed = 1;
						totalAppsUsedRef.set(totalAppUsed);
						console.log('SESSION SHOULD OF BEEN EXTENDED');
					}
				});
		};
	}

	stopPresentation() {
		console.log('presentation stopping furioos stopping');
		this.player.stop();
	}

	//GET INFORMATION FROM UNITY

	getCategories (){

		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "getInfo",
				requestInfo: "showCategories",
				category: "",
				unit: "",
				room: "",
				upgrade: "",
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);

	}

	getUnitsByCategory (categoryName){
		console.log("Get units by " + categoryName);

		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "getInfo",
				requestInfo: "unitsCategory",
				category: categoryName,
				unit: "",
				room: "",
				upgrade: "",
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);

	}

	getUnitRooms (unitId){
		//get the units
		//self.player.sendSDKMessage(thisBody);
		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "getInfo",
				requestInfo: "unitAllRooms",
				category: "",
				unit: unitId,
				room: "",
				upgrade: "",
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);
	}


	getAllUpgrades(unitId){
		//get all upgrades and rooms 
		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "getInfo",
				requestInfo: "unitAllRooms",
				category: "",
				unit: unitId,
				room: "",
				upgrade: "",
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);
	}

	getRoomUpgrades(roomId, unitId){
		//roomUpgrades
				//get the units
		//self.player.sendSDKMessage(thisBody);
		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "getInfo",
				requestInfo: "roomUpgrades",
				category: "",
				unit: unitId,
				room: roomId,
				upgrade: "",
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);
	}

	//POPULATE INFRO FROM CATEGORIES

	goToUnit (unitId){
		console.log("Go to units by " + unitId);

		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "goTo",
				requestInfo: "unit",
				category: "",
				unit: unitId,
				room: "",
				upgrade: "",
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);

	}

	goToRoom (roomId, unitId){
		//get the units
		//self.player.sendSDKMessage(thisBody);
		console.log("GO TO ROOM " + roomId);
		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "goTo",
				requestInfo: "room",
				category: "",
				unit: unitId,
				room: roomId,
				upgrade: "",
				map: ""				
			}
		}

		this.currentUiState = "inRoomZoom";

		self.player.sendSDKMessage(bodyToSend);

		

		
	}


	setOption(thisOption){

		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "goTo",
				requestInfo: "upgrade",
				category: "",
				unit: this.currentUnitId,
				room: this.currentRoomId,
				upgrade: thisOption.id,
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);
	}

	unityGoBack (){
		console.log("Go back on unity");

		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "goBack",
				requestInfo: "",
				category: "",
				unit: "",
				room: "",
				upgrade: "",
				map: ""				
			}
		}
		console.log("GOING BACK CURRENT STATE " + this.currentUiState);
		

		//inUnit
		//inRoom
		//inUpgrade
		//inOption
		//getUnitRooms
		console.log("CURRENT UI STATE " + this.currentUiState);

		self.player.sendSDKMessage(bodyToSend);
		// if(this.currentUiState === "inCategory"){
			

	}

	setZoomTo (thisZoom){

		console.log("zoomTo has been called");
	
		var self = this;

		var bodyToSend = {apiInfo: 
			{
				requestType: "zoomTo",
				requestInfo: thisZoom,
				category: "",
				unit: "",
				room: "",
				upgrade: "",
				map: ""				
			}
		}

		self.player.sendSDKMessage(bodyToSend);
	
		
	}

}

export default CallFurioos;
